import { render, staticRenderFns } from "./reset-verify-phone.vue?vue&type=template&id=473152d7&scoped=true&"
import script from "./reset-verify-phone.vue?vue&type=script&lang=js&"
export * from "./reset-verify-phone.vue?vue&type=script&lang=js&"
import style0 from "./reset-verify-phone.vue?vue&type=style&index=0&lang=css&"
import style1 from "./reset-verify-phone.vue?vue&type=style&index=1&id=473152d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473152d7",
  null
  
)

export default component.exports